import { useTranslation } from 'react-i18next';
import { ApiError, ContractError, NetworkError } from '../api/client';

export function errorMessageKey(err: unknown): string {
  if (err instanceof NetworkError) return 'errors.network';
  if (err instanceof ContractError) return 'errors.contract';
  if (err instanceof ApiError) {
    if (err.status === 403) return 'errors.forbidden';
    if (err.status === 404) return 'errors.notFound';
    if (err.status === 409) return 'errors.conflict';
    if (err.status === 413 || err.status === 422) return 'errors.limit';
    return 'errors.server';
  }
  return 'errors.unknown';
}

export function ErrorBox({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  const rid = error instanceof ApiError && error.requestId ? error.requestId : null;
  return (
    <div className="error-box" role="alert">
      <p>{t(errorMessageKey(error))}</p>
      {error instanceof ApiError && <p className="muted">{error.message}</p>}
      {rid && <p className="muted small">{t('errors.requestId', { id: rid })}</p>}
      {onRetry && (
        <button type="button" className="btn" onClick={onRetry}>
          {t('action.retry')}
        </button>
      )}
    </div>
  );
}
